/**
 * Service Templates Index
 *
 * Aggregates all service templates from individual service files
 */

import { hubspotTemplate } from './hubspot.js'
import { salesforceTemplate } from './salesforce.js'
import { mailchimpTemplate } from './mailchimp.js'
import { shopifyTemplate } from './shopify.js'
import { marketoTemplate } from './marketo.js'
import { slackTemplate } from './slack.js'
import { zendeskTemplate } from './zendesk.js'
import { adobeMarketingTemplate } from './adobe-marketing.js'
import { brazeTemplate } from './braze.js'
import { klaviyoTemplate } from './klaviyo.js'
import { activecampaignTemplate } from './activecampaign.js'
import { segmentTemplate } from './segment.js'
import { onesignalTemplate } from './onesignal.js'
import { jiraTemplate } from './jira.js'
import { slackWebhookTemplate } from './slack-webhook.js'
import { servicenowTemplate } from './servicenow.js'
import { freshdeskTemplate } from './freshdesk.js'
import { zohoDeskTemplate } from './zoho-desk.js'
import { pagerdutyTemplate } from './pagerduty.js'

/**
 * All system integration templates aggregated from individual service files
 */
export const SYSTEM_TEMPLATES = [
	hubspotTemplate,
	salesforceTemplate,
	mailchimpTemplate,
	shopifyTemplate,
	marketoTemplate,
	slackTemplate,
	zendeskTemplate,
	adobeMarketingTemplate,
	brazeTemplate,
	klaviyoTemplate,
	activecampaignTemplate,
	segmentTemplate,
	onesignalTemplate,
	jiraTemplate,
	slackWebhookTemplate,
	servicenowTemplate,
	freshdeskTemplate,
	zohoDeskTemplate,
	pagerdutyTemplate
]

export default SYSTEM_TEMPLATES
